import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PolitiqueCookiesPage = () => (
  <div className="min-h-screen bg-slate-50 text-slate-800">
    <header className="bg-white border-b border-slate-200 py-4">
      <div className="max-w-4xl mx-auto px-4 flex items-center justify-between">
        <Link to="/" className="font-bold text-lg font-['Manrope']">
          <span className="text-emerald-600">Capsule</span> Patrimoine
        </Link>
        <Link to="/" className="text-sm text-slate-600 hover:text-emerald-700 inline-flex items-center gap-1" data-testid="back-home-link">
          <ArrowLeft className="h-4 w-4" /> Accueil
        </Link>
      </div>
    </header>
    <main className="max-w-4xl mx-auto px-4 py-10">
      <h1 className="text-3xl sm:text-4xl font-bold font-['Manrope'] mb-8 text-slate-900">Politique cookies</h1>
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 sm:p-10 prose prose-slate max-w-none prose-headings:font-['Manrope'] prose-h2:text-xl prose-h2:mt-8 prose-h2:mb-3 prose-a:text-emerald-700">

        <h2>Qu&apos;est-ce qu&apos;un cookie ?</h2>
        <p>Un cookie est un petit fichier texte déposé sur votre appareil lors de la visite d&apos;un site. Il permet de mémoriser des informations relatives à votre navigation (préférences, session, statistiques, publicité).</p>

        <h2>Cookies utilisés par Capsule Patrimoine</h2>
        <table className="not-prose w-full border-collapse text-sm">
          <thead>
            <tr className="bg-slate-100">
              <th className="border border-slate-300 p-2 text-left">Nom / Type</th>
              <th className="border border-slate-300 p-2 text-left">Finalité</th>
              <th className="border border-slate-300 p-2 text-left">Durée</th>
              <th className="border border-slate-300 p-2 text-left">Consentement</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border border-slate-300 p-2"><strong>access_token</strong><br/>(httpOnly, Secure)</td>
              <td className="border border-slate-300 p-2">Authentification de session (JWT)</td>
              <td className="border border-slate-300 p-2">7 jours</td>
              <td className="border border-slate-300 p-2">Nécessaire (exempt)</td>
            </tr>
            <tr>
              <td className="border border-slate-300 p-2"><strong>cp_cookie_consent</strong> (localStorage)</td>
              <td className="border border-slate-300 p-2">Mémorisation de votre choix cookies</td>
              <td className="border border-slate-300 p-2">12 mois</td>
              <td className="border border-slate-300 p-2">Nécessaire (exempt)</td>
            </tr>
            <tr>
              <td className="border border-slate-300 p-2"><strong>Compteur de visites first-party</strong><br/>(aucun cookie, aucun stockage)</td>
              <td className="border border-slate-300 p-2">Statistiques anonymes de fréquentation et de clics (visites, provenance, offre cliquée). Un hash technique renouvelé chaque jour sert uniquement à ne pas compter deux fois la même visite ; aucune adresse IP n&apos;est conservée.</td>
              <td className="border border-slate-300 p-2">—</td>
              <td className="border border-slate-300 p-2">Hors champ consentement (rien n&apos;est lu ni écrit sur votre appareil)</td>
            </tr>
            <tr>
              <td className="border border-slate-300 p-2"><strong>ph_*</strong> (PostHog, mesure d&apos;audience)</td>
              <td className="border border-slate-300 p-2">Analyse des parcours de visite et des conversions, sans enregistrement d&apos;écran</td>
              <td className="border border-slate-300 p-2">13 mois</td>
              <td className="border border-slate-300 p-2">Requiert votre consentement</td>
            </tr>
            <tr>
              <td className="border border-slate-300 p-2"><strong>_fbp</strong> (Meta Pixel)</td>
              <td className="border border-slate-300 p-2">Publicité Facebook, mesure de conversion des campagnes</td>
              <td className="border border-slate-300 p-2">3 mois</td>
              <td className="border border-slate-300 p-2">Requiert votre consentement</td>
            </tr>
          </tbody>
        </table>

        <h2>Gérer vos choix</h2>
        <p>Lors de votre première visite, une bannière vous permet d&apos;<strong>accepter</strong> ou <strong>refuser</strong> les cookies non essentiels (Facebook Pixel). Votre choix est mémorisé pour 12 mois.</p>
        <p>Pour modifier ou retirer votre accord à tout moment :</p>
        <p>
          <button type="button" onClick={() => window.dispatchEvent(new Event('cp-open-consent'))} className="not-prose inline-flex items-center rounded-full bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold px-5 py-2.5" data-testid="manage-cookies-btn">
            Gérer mes cookies
          </button>
        </p>
        <p>Le retrait de votre accord supprime les cookies de mesure déposés (PostHog, Meta) et arrête toute mesure non anonyme. Vous pouvez aussi vider les cookies du site depuis votre navigateur.</p>
        <p>Vous pouvez également refuser les cookies via les paramètres de votre navigateur : <a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Chrome</a>, <a href="https://support.mozilla.org/fr/kb/effacer-cookies-donnees-site-firefox" target="_blank" rel="noopener noreferrer">Firefox</a>, <a href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a>.</p>

        <h2>Impact du refus</h2>
        <p>Refuser les cookies non essentiels n&apos;affecte <strong>pas</strong> le fonctionnement du Service. Seule la mesure d&apos;audience publicitaire (nécessaire à l&apos;optimisation des campagnes Facebook) est désactivée.</p>

        <h2>Contact</h2>
        <p>Pour toute question relative aux cookies : <a href="mailto:contact@capsulepatrimoine.com">contact@capsulepatrimoine.com</a></p>
      </div>
      <div className="mt-6 text-xs text-slate-500 text-center">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</div>
    </main>
  </div>
);

export default PolitiqueCookiesPage;
